<template>
  <div style="position:relative;" class="wp">
    <div class="water" :style="{background:wColor}" v-if="type" @mouseover="showRant=true" @mouseout="showRant=false">{{text}}
    </div>
    <img class="rant" v-if="showRant && url" :src="require('@/assets/img/rant/'+url+'.png')">
  </div>
</template>

<script>
export default {
  props: ['type', 'num', 'left', 'top'],
  data () {
    return {
      wColors: ['#52DB75', '#FCBC05', '#FF8719', '#E25F5F', '#7A65DB', '#A33C6B'],
      wColor: '#52DB75',
      text: '',
      showRant: false,
      url: 'aqi',
      unit: null,
      texts: [
        {
          cha: '优秀',
          eng: 'excellent'
        },
        {
          cha: '良好',
          eng: 'fine'
        },
        {
          cha: '合格',
          eng: 'qualified'
        },
        {
          cha: '轻度污染',
          eng: 'Slightly polluted'
        },
        {
          cha: '重度污染',
          eng: 'heavy pollution'
        }
      ],
      // 颜色和单位配置
      colorConfig: {
        pm25: {
          hasUnit: true,
          unit: {
            'mg/m³': {
              url: 'PM2.5mg',
              rate: 0.001,
              value: [25 * 0.001, 35 * 0.001, 75 * 0.001, 300 * 0.001]
            },
            'μg/m³': {
              url: 'PM2.5μg',
              rate: 1,
              value: [25, 35, 75, 300]
            }
          }
        },
        pm10: {
          hasUnit: true,
          unit: {
            'mg/m³': {
              url: 'PM10mg',
              rate: 0.001,
              value: [35 * 0.001, 75 * 0.001, 100 * 0.001, 200 * 0.001]
            },
            'μg/m³': {
              url: 'PM10μg',
              rate: 1,
              value: [35, 75, 100, 200]
            }
          }
        },
        tvoc: {
          hasUnit: true,
          unit: {
            'mg/m³': {
              url: 'TVOCmg',
              rate: 0.0013,
              value: [154 * 0.0013, 230 * 0.0013, 460 * 0.0013, 2300 * 0.0013]
            },
            ppb: {
              url: 'TVOCppb',
              rate: 1,
              value: [154, 230, 460, 2300]
            }
          }
        },
        hcho: {
          hasUnit: true,
          unit: {
            'mg/m³': {
              url: 'HCHOmg',
              rate: 0.0012,
              value: [25 * 0.0012, 42 * 0.0012, 84 * 0.0012, 666 * 0.0012]
            },
            ppb: {
              url: 'HCHOppb',
              rate: 1,
              value: [25, 42, 84, 666]
            }
          }
        },
        co2: {
          hasUnit: false,
          url: 'CO2ppm',
          value: [550, 900, 1000, 2000]
        },
        ihai: {
          hasUnit: false,
          url: 'ihai',
          value: [89, 74, 59, 49, 0]
        },
        aqi: {
          canChange: false,
          hasUnit: false,
          url: 'aqi',
          value: [50, 100, 150, 200]
        },
        // 病毒指数(>=50 优秀，<50 良好)
        dvi: {
          hasUnit: false,
          url: '',
          value: [49, 0]
        }
      }
    }
  },
  mounted () {
    this.unit = JSON.parse(window.localStorage.getItem('unit'))
    this.config(this.type)
  },
  methods: {
    config (value) {
      var item = this.colorConfig[value]
      if (item) {
        var text
        if (item.hasUnit) {
          var unit = this.unit[value]
          this.url = item.unit[unit].url
          this.wColor = this.wColors[this.Index(this.num, item.unit[unit].value)]
          text = this.texts[this.Index(this.num, item.unit[unit].value)]
        } else {
          this.url = item.url
          this.wColor = this.wColors[this.Index(this.num, item.value)]
          text = this.texts[this.Index(this.num, item.value)]
          if (this.type === 'dvi' && text.eng === 'fine') {
            text.cha = '需注意'
          }
        }
        this.text = this.$store.state.module1.isChina ? text.cha : text.eng
      }
    },
    // 根据值和数组返回对应的位置
    Index (num, values) {
      var dex = 0
      if (this.type === 'ihai' || this.type === 'dvi') {
        for (var i = 0; i < values.length; i++) {
          if (parseFloat(num) > values[i]) {
            dex = i
            break
          }
        }
      } else {
        if (num > values[values.length - 1]) {
          dex = values.length
        } else {
          for (var j = 0; j < values.length; j++) {
            if (parseFloat(num) <= values[j]) {
              dex = j
              break
            }
          }
        }
      }
      return dex
    }
  },
  watch: {
    type (value) {
      this.$nextTick(() => {
        this.config(value)
      })
    },
    num () {
      this.$nextTick(() => {
        this.config(this.type)
      })
    }
  }
}
</script>

<style scoped>
.water{
 border-radius: 0.16rem 0.16rem 0.16rem 0.04rem;
 padding:0.05rem 0.14rem;
 color:white;
 font-size:0.14rem;
 cursor:pointer;
}
 .rant{
  position:absolute;
  z-index:200;
  left:80%;top:5%;
  width:2rem;
  height:2.4rem;
}
</style>
